module.exports = __webpack_public_path__ + "static/media/HCMM279.73a6d904.jpg";